import { render, staticRenderFns } from "./ItemsWrapper.vue?vue&type=template&id=616e7f6c&"
import script from "./ItemsWrapper.vue?vue&type=script&lang=js&"
export * from "./ItemsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports